// Import from accessor module
import clientAccessor from "./apolloClientAccessor";

export default clientAccessor;
